import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface ICustomTooltip {
  name: string;
  children: React.ReactNode;
  icon?: IconProp;
  className?: string;
}

const CustomTooltip = (props: ICustomTooltip) => {
  return (
    <OverlayTrigger
      overlay={<Tooltip id={props.name}>{props.children}</Tooltip>}
    >
      <FontAwesomeIcon
        icon={props.icon || faInfoCircle}
        className={props.className}
      />
    </OverlayTrigger>
  );
};

export default CustomTooltip;
